import React from 'react';
import cn from 'clsx';
import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { CreatePollData } from '../types';

import ButtonMighty from '@components/elements/ButtonMighty';
import Toggle from '@components/elements/Toggle';

import QuestionForm from './QuestionForm';
import PollCreateQuestionList from './QuestionList';
import Card from '@components/elements/Card';
import PollPeriodInput from '@components/modules/Poll/PeriodInput';
import { Tier } from '@sdk/API';
import { useAuth } from '@hooks/Auth';
import InputText from '@components/elements/InputText';
import { LOCATION_LIST } from '@sdk/managers/UsersManager';
import { useHistory } from 'react-router-dom';

interface PollCreateStepTwoProps {
  isEdit: boolean;
  isSubmitting?: boolean;
  onNext: () => void;
  onBack: () => void;
  neon: string;
}

const PollCreateStepTwo: React.FC<PollCreateStepTwoProps> = ({
  isSubmitting = false,
  isEdit,
  onNext,
  onBack,
  neon,
}) => {
  const [active, setActive] = React.useState<number>();

  const { dbUser } = useAuth();
  const form = useFormContext<CreatePollData>();

  const formPremium = form.watch('isPremium');
  const formCompany = form.watch('company');
  const isGroup = form.watch('group');
  const isPledge = form.watch('pledging');
  const history = useHistory();
  const { isValidating } = useFormState();
  const loading = isSubmitting || isValidating;

  let pledgePermission =
    formPremium ||
    formCompany ||
    dbUser?.permissions?.pledgeAllowed ||
    dbUser?.tier === Tier.ENTERPRISE ||
    dbUser?.tier === Tier.CONSULTATIVE;
  const dropdownCn =
    'bg-transparent py-3 px-2 w-full font-display text-sm outline-none placeholder-opacity-80 focus:placeholder-opacity-40 text-white text-opacity-100 focus:text-opacity-80 placeholder-purple';

  return (
    <div className="min-h-screen pt-12 pb-32 bg-black px-4">
      <div className="container mx-auto relative">
        {/* {isEdit && (
          <Card
            bgColor="blue"
            shadowColor="magenta"
            className="p-4 my-8"
            neon={neon}
          >
            <h2 className="mb-4 text-2xl" style={{ color: neon }}>
              {' '}
              Poll Period{' '}
            </h2>
            <Controller
              name="period"
              control={form.control}
              render={({ field: { value, ...field } }) => (
                <PollPeriodInput
                  neon={neon}
                  isEdit={isEdit}
                  onChange={field.onChange}
                  value={value}
                />
              )}
            />
          </Card>
        )} */}

        {/* {pledgePermission && isEdit && (
          <Controller
            name="pledging"
            control={form.control}
            render={({ field }) => (
              <div className="py-4">
                <Card
                  bgColor="white"
                  className="p-4 mb-8"
                  shadowColor="blue"
                  neon={neon}
                >
                  <div className="flex flex-row w-full mb-2 items-between">
                    <h2
                      className="w-full mb-1 mr-4 text-2xl "
                      style={{ color: neon }}
                    >
                      Pledging
                    </h2>
                    <div className="flex items-center">
                      <Toggle {...field} activeClassName="bg-blue" />
                    </div>
                  </div>
                  <p className="text-sm " style={{ color: neon }}>
                    Enable Pledging for your poll
                  </p>
                </Card>

                {field.value === true && (
                  <Card bgColor="blue" shadowColor="magenta" className="p-4">
                    <h2 className="mb-4 text-2xl">Pledge Period</h2>
                    <Controller
                      name="pledgePeriod"
                      control={form.control}
                      render={({ field: { value, ...field } }) => (
                        <PollPeriodInput
                          neon={neon}
                          isEdit={isEdit}
                          onChange={field.onChange}
                          value={value}
                          allowImmediate={false}
                        />
                      )}
                    />
                  </Card>
                )}
              </div>
            )}
          />
        )} */}
        {isGroup && active !== undefined ? (
          <QuestionForm
            neon={neon}
            index={active}
            pledging={active === 0 && isPledge}
            toPledge={form.getValues('toPledge') || false}
            isGroup={isGroup}
            isEdit={isEdit}
            onClose={() => {
              setActive(undefined);
            }}
          />
        ) : (
          <>
            <div className="">
              <h1 className="text-4xl" style={{ color: neon }}>
                {isEdit
                  ? `Edit ${isPledge ? 'Pledge Statement' : 'Poll Questions'}`
                  : `${isPledge ? 'Pledge Statement' : 'Poll Questions'} `}
              </h1>
            </div>

            {isGroup ? (
              <PollCreateQuestionList
                neon={neon}
                onItemClickEdit={(index) => setActive(index)}
              />
            ) : (
              <QuestionForm
                pledging={isPledge}
                toPledge={form.getValues('toPledge') || false}
                index={0}
                neon={neon}
                isGroup={false}
                isEdit={isEdit}
                onClose={() => setActive(undefined)}
                loading={loading}
              />
            )}
            {pledgePermission && (
              <h2
                className="text-4xl mt-4"
                style={{ color: neon, marginTop: 100 }}
              >
                Other Options
              </h2>
            )}
            <div className="grid n-col-2 my-4">
              {pledgePermission && (
                <Controller
                  name="password"
                  control={form.control}
                  render={({ field, fieldState: { error: fieldError } }) => {
                    const isEnabled = field.value?.length !== undefined;
                    return (
                      <div className="space-y-4">
                        <Card
                          bgColor="white"
                          className="p-4"
                          shadowColor="blue"
                          neon={neon}
                          style={{ borderBottom: '2px solid ' + neon }}
                        >
                          <div className="flex flex-row w-full mb-2 items-between">
                            <h2 className="w-full mb-1 mr-4 text-2xl text-white">
                              Password
                            </h2>
                            <div className="flex items-center">
                              <Toggle
                                value={isEnabled}
                                onChange={(value) => {
                                  field.onChange(value ? '' : undefined);
                                }}
                                activeClassName="bg-blue"
                              />
                            </div>
                          </div>
                          <p className="text-sm text-white">
                            Password protect your poll
                          </p>

                          {isEnabled && (
                            <>
                              <InputText
                                className="mt-2"
                                type="password"
                                shadow={false}
                                neon={true}
                                placeholder="Poll passsword*"
                                value={field.value}
                                onChange={field.onChange}
                              />
                              {fieldError && (
                                <div className="flex justify-end px-2 text-sm font-semibold text-red">
                                  {fieldError.message}
                                </div>
                              )}
                            </>
                          )}
                        </Card>
                      </div>
                    );
                  }}
                />
              )}
              {pledgePermission && (
                <Controller
                  name="grc"
                  control={form.control}
                  render={({ field, fieldState: { error: fieldError } }) => {
                    const isEnabled =
                      field.value?.length !== undefined &&
                      field.value !== 'Any';

                    return (
                      <div className="mb-8">
                        <Card
                          bgColor="white"
                          className="p-4 space-y-4"
                          shadowColor="blue"
                          neon={neon}
                          style={{ borderBottom: '2px solid ' + neon }}
                        >
                          <h2 className="w-full mb-1 mr-4 text-2xl text-white">
                            Location
                          </h2>
                          <p className="mb-4 text-sm text-white">
                            Enable location based poll
                          </p>
                          <div>
                            <h3 className="w-full mb-1 mr-4 text-lg text-white">
                              GRC
                            </h3>
                            <select
                              className={cn(dropdownCn)}
                              defaultValue="Default"
                              onChange={(e) => {
                                field.onChange(e);
                                const value = e.target.value;
                                if (value === 'Any') {
                                  form.setValue('division', undefined);
                                }
                              }}
                              value={field.value}
                            >
                              <option value="Any">Any</option>
                              {Object.keys(LOCATION_LIST).map((grc) => (
                                <option
                                  key={`grc-${grc}`}
                                  className="capitalize text-black"
                                  value={grc}
                                >
                                  {grc}
                                </option>
                              ))}
                            </select>
                            {fieldError && (
                              <p className="text-red">*{fieldError.message}</p>
                            )}
                          </div>

                          {isEnabled && (
                            <div>
                              <h3 className="w-full mb-1 mr-4 text-lg text-white">
                                Division
                              </h3>
                              <select
                                className={cn(dropdownCn)}
                                defaultValue="Default"
                                {...form.register('division')}
                              >
                                <option value="Any">Any</option>
                                {field.value !== undefined &&
                                  LOCATION_LIST[field.value].map((division) => (
                                    <option
                                      key={`division-${division}`}
                                      className="capitalize text-black"
                                      value={division}
                                    >
                                      {division}
                                    </option>
                                  ))}
                              </select>
                              {form.formState.errors.division && (
                                <p className="text-red">
                                  *{form.formState.errors.division.message}
                                </p>
                              )}
                            </div>
                          )}
                        </Card>
                      </div>
                    );
                  }}
                />
              )}
            </div>

            <div className="flex flex-col  space-y-4">
              <div
              // className={cn({
              //   'opacity-60': isEdit && !isDirty,
              // })}
              >
                <ButtonMighty
                  style={{
                    position: 'absolute',
                    bottom: -50,
                    right: 0,
                    width: form.getValues('toPledge')
                      ? '100%'
                      : 'calc(100% - 240px)',
                    background: neon,
                    color: 'black',
                  }}
                  neon={neon}
                  disabled={loading || isSubmitting}
                  loading={loading || isSubmitting}
                  color="#29FF2E"
                  text={
                    isEdit
                      ? 'Save Changes'
                      : form.getValues('toPledge')
                      ? 'Direct to Pledge'
                      : `Create ${isPledge ? 'Pledge' : 'Poll'}`
                  }
                  onClick={() => onNext()}
                  borderColor="#4400FF"
                  margin="0"
                  textColor="#4400FF"
                />
                {isEdit && (
                  <div
                    style={{
                      width: '100%',
                      position: 'absolute',
                      left: 0,
                      bottom: -120,
                    }}
                  >
                    {' '}
                    <ButtonMighty
                      text={`VIEW POLL WITHOUT SAVING CHANGE`}
                      onClick={() =>
                        history.push(
                          window.location.pathname.replace('/edit', '')
                        )
                      }
                      neon={neon}
                      borderColor="#fff"
                      margin="0"
                      textColor="#fff"
                      color="#221f20"
                      width="auto"
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PollCreateStepTwo;
